import targets from './salesDataTargets.json';

export const MONTHS = ['Jan', 'Feb', 'Mars', 'April', 'Maj', 'Juni', 'Juli', 'Aug', 'Sept', 'Okt', 'Nov', 'Dec'];

export const FROM_DATE = `${targets.year}-01-01`;
export const TO_DATE = `${targets.year}-12-31`;

// Number of days covered by each request while loading invoices
export const DAYS_PER_REQUEST = 2;

export const SEARCH_MIN_LENGTH = 2;
export const SEARCH_MAX_RESULTS = 100;
